import { useRef, useEffect } from 'react';
import { useLatest } from './useLatest.js';

/**
 * @param value Значение для дебаунса
 * @param delay Задержка
 * @param callback Функция которую нужно выполнить после задержки
 */

var useDebounce = function useDebounce(value, delay, callback) {
  var latestCallback = useLatest(callback);
  var isMounted = useRef(false);
  useEffect(function () {
    // Не запускаем дебаунс при первом рендере - повторяет старое поведение с keyup.
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }

    var timeout = setTimeout(function () {
      latestCallback.current(value);
    }, delay);
    return function () {
      clearTimeout(timeout);
    };
  }, [value, delay]);
};

export { useDebounce as default, useDebounce };
